export default __webpack_public_path__ + "static/colombians-abroad-308a61e3dec4e865081e5188ddbce104.png";